import React, { useState } from 'react';
import { FaTimes } from 'react-icons/fa';
import axios from 'axios';
import serverURL from '../config'; // Adjust the import based on your project structure
import { toast } from 'react-toastify'; // Import toast

const BulkQuesModal = ({ onClose, categoryId }) => {
    const [jsonInput, setJsonInput] = useState('');
    const [showPreview, setShowPreview] = useState(false); // State to manage preview modal visibility

    const handleSubmit = async () => {
        try {
            const questions = JSON.parse(jsonInput); // Parse the JSON input
            const token = localStorage.getItem('token'); // Get the token

            // Make the API call to submit the questions
            const response = await axios.post(`${serverURL}/questions/bulk-upload/${categoryId}`, questions, {
                headers: {
                    Authorization: `Bearer ${token}`,
                    'Content-Type': 'application/json',
                },
            });

            console.log('Bulk questions added:', response.data);
            toast.success('Questions added successfully!'); // Show success toast
            onClose(); // Close the modal
        } catch (error) {
            console.error('Failed to add bulk questions:', error.response ? error.response.data : error.message);
            toast.error('Failed to add bulk questions. Please check your input.'); // Show error toast
        }
    };

    return (
        <div className="p-4 max-h-[80vh] overflow-y-auto">
            <div className="flex justify-between items-center mb-4">
                <h3 className="text-lg font-bold">Bulk Upload Questions</h3>
                {/* <button className="text-gray-500" onClick={onClose}>
                    <FaTimes size={20} />
                </button> */}
            </div>

            <textarea
                value={jsonInput}
                onChange={(e) => setJsonInput(e.target.value)} // Update state with textarea input
                rows="10"
                className="w-full h-3/4 p-2 border rounded"
                placeholder="Paste your JSON array here..."
            />

            {/* Preview JSON Button */}
            <div className="flex justify-between mt-2">
                <button
                    className="bg-gray-500 text-white p-2 rounded mr-2"
                    onClick={() => setShowPreview(true)} // Show preview modal
                >
                    Preview JSON
                </button>
                <div>
                    <button className="bg-gray-500 text-white p-2 rounded mr-2" onClick={onClose}>
                        Cancel
                    </button>
                    <button className="bg-red-500 text-white p-2 rounded" onClick={handleSubmit}>
                        Submit
                    </button>
                </div>
            </div>

            {/* Preview Modal */}
            {showPreview && (
                <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50">
                    {/* Modal content */}
                    <div className="bg-white p-6 rounded-lg shadow-lg w-11/12 md:w-1/2 max-h-screen overflow-y-auto">

                        <h4 className="text-lg font-bold mb-4">JSON Preview</h4>
                        <pre className="bg-gray-100 p-2 rounded-md overflow-x-auto max-h-[70vh] overflow-y-auto">
                            {`[
                                {
                                    "category_id": 1,
                                    "question_text": "What is Node.js?",
                                    "points": 10,
                                    "question_type": "MCQ",
                                    "options": [
                                        {
                                            "option_text": "A runtime environment",
                                            "is_correct": true
                                        },
                                        {
                                            "option_text": "A programming language",
                                            "is_correct": false
                                        }
                                    ]
                                },
                                {
                                    "category_id": 1,
                                    "question_text": "Write a function to sort an array",
                                    "points": 20,
                                    "question_type": "Programming",
                                    "programming_details": {
                                        "programming_language": "Python",
                                        "input_format": "Array of integers",
                                        "output_format": "Sorted array",
                                        "sample_input": "[5,2,8,1,9]",
                                        "sample_output": "[1,2,5,8,9]",
                                        "time_limit": 1000,
                                        "memory_limit": 256
                                    },
                                    "test_cases": [
                                        {
                                            "input_data": "[5,2,8,1,9]",
                                            "expected_output": "[1,2,5,8,9]"
                                        },
                                        {
                                            "input_data": "[10,8,6,4,2]",
                                            "expected_output": "[2,4,6,8,10]"
                                        }
                                    ]
                                }
                            ]`}
                        </pre>
                        <div className="flex justify-end mt-4">
                            <button
                                className="bg-gray-300 text-black p-2 rounded"
                                onClick={() => setShowPreview(false)} // Close preview modal
                            >
                                Close
                            </button>
                        </div>
                    </div>
                </div>
            )}

        </div>
    );
};

export default BulkQuesModal;
